import React from 'react';
import {connect} from 'react-redux';

import HomepageColumn from 'components/homepage-layouts/HomepageColumn';
import {openAddHomepageItemModal} from 'components/homepage-layouts/items/AddItemModal/actions';

const mapStateToProps = (state) => {
  return {

  }
}

const mapDispatchToProps = (dispatch) => ({
  showAddItemModal: (homepageColumnId, homepageSectionId) => dispatch(openAddHomepageItemModal(homepageColumnId, homepageSectionId))
});

const ConnectedHomepageColumn = connect(mapStateToProps, mapDispatchToProps)(HomepageColumn);

export default ConnectedHomepageColumn;



// WEBPACK FOOTER //
// ./public/components/homepage-layouts/HomepageColumnContainer.jsx